import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CriminalRecordStatuteBatchRow, StatuteCrumbs, StatuteCategoryMapping, CrimSubCategory } from '../crimgrid-module/models/batch-row'

@Injectable({
  providedIn: 'root'
})
export class ScrubberDataService {

  constructor(private http : HttpClient, public toast : ToastrService ) { }
  _statesList : string[];
  _chargesToWork : CriminalRecordStatuteBatchRow[];
  _plotData : StatuteCrumbs[];
  _categories : CrimSubCategory[];
  chargesLoading: boolean = false;
  public $plotRecordsLoaded : EventEmitter<boolean> = new EventEmitter();


    
    public get categories() : CrimSubCategory[] {
      if(this._categories){
        return this._categories.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
      }
      return 
    }
    

  getStateList(){
    return this.http.get(environment.baseURl + `/api/crimadmin/states`).pipe().subscribe(
      (scs: any) => {
        this._statesList = scs.sort((a,b) => a.localeCompare(b));
      },
      (err: any) => {
        this.toast.error('ADDRESS RECORD LOAD ERROR')
      },
    );
  }

  loadCharges(stateCode : string, statute : number){
    this.chargesLoading = true;
    this.http.get(environment.baseURl + `/api/crimadmin/charges/${stateCode}/${statute}`).pipe().subscribe(
      (scs: any) => {
        this._chargesToWork = scs.map(e => Object.assign(new CriminalRecordStatuteBatchRow, e));
      },
      (err: any) => {
        this.toast.error('ADDRESS RECORD LOAD ERROR')
      },()=>{this.chargesLoading = false;}
    );
  }


  loadCategories(){
    return this.http.get(environment.baseURl + `/api/crimadmin/categories`).pipe().subscribe(
      (scs: any) => {
        this._categories = scs.map(e => Object.assign(new CrimSubCategory, e));
      },
      (err: any) => {
        this.toast.error('Crim sub category load error')
      },
    );
  }

  loadStatuteCategoryMappings( statute : number){
    return this.http.get(environment.baseURl + `/api/crimadmin/statute/category/${statute}`);
  }

  setStatuteCategoryMappings( statute : number, category : number){
    return this.http.get(environment.baseURl + `/api/crimadmin/statute/category/${statute}/${category}`);
  }

  clearChargeFromStatuteGroup(statute : number, chargeId : number){
    return this.http.get(environment.baseURl + `/api/crimadmin/charge/wipe/${statute}/${chargeId}`);
  }

  loadStatuteBreakout(stateCode : string, offset : number, fetch : number){
    this.http.get(environment.baseURl + `/api/crimadmin/statute/maps/${stateCode}/${offset}/${fetch}`).pipe().subscribe(
      (scs: any) => {
        this._plotData = scs.map(e => Object.assign(new StatuteCrumbs, e));
        // console.log(this._plotData);
        this.$plotRecordsLoaded.next(true);
      },
      (err: any) => {
        this.toast.error('Statute Plot Data Load Error')
      },
    );
  }
}


